export default "__VITE_ASSET__B2kxABl6__"